// extracted by mini-css-extract-plugin
export default {"officialPastItem":"index_officialPastItem__hSS8J","pastDrawerListWrap":"index_pastDrawerListWrap__sc7J3"};